import { getCookie } from '@/utils/cookie';

const BLOCK_ANALYTICS_COOKIE = 'akamai_bot';
const DEFAULT_BLOCKED_AKAMAI_VALUES = [
  'd4a98bd8b46c4586987099f9bb5bb421',
  '3f3c6105f19043df8d239af5b5f1d230',
  '27c7b33edafc45d2841b954cc535be92',
  'cb9fc996be4d4cf9ab234603c8020644',
  '779d5ee50b974d43ab841f535ce3e4b3',
  'be09197092bb4438bea8bfe5cecc1fc2',
  '5b35df16244e47309a9b15aed65cbfae',
  'e6cad9cbc6ef4594977368f6f4f5374c',
  '70159f3c50e94af1a638f815a225fe55',
  '3c6661053e894f44a0d02372609de6ad',
  'b0c2facd97974b8eb81c056415c2546d',
  'e67c36c0cf87415ba111c35486f28a11',
  'c4c9e1c4bc4d4dc88940c2b47e01e754',
  '1e399daee50241a3acaf56f7348732f9',
  '32284a5800cd409a84da74da79c0ccda',
  'cf0a10efb2c0403086bfcca60924258f',
  'ed18683870e8475cb22b829a7dbb4202',
  '73b863d76fdc4cd49c08bf7ee478d9da',
  '4efb0e74757742deb95d146f894d0b18',
  '0c0a4b23a19d41a5abeaa4005a8a8abf',
].join(',');

const BLOCKED_VALUES_STRING =
  process.env.NEXT_PUBLIC_AKAMAI_BLOCKED_VALUES || DEFAULT_BLOCKED_AKAMAI_VALUES;
const BLOCKED_AKAMAI_VALUES = BLOCKED_VALUES_STRING.split(',')
  .map((v) => v.trim())
  .filter(Boolean);

/**
 * Checks if analytics events should be blocked based on business rules
 */
export function shouldBlockAnalytics(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const cookieValue = getCookie(BLOCK_ANALYTICS_COOKIE);
  return !!(cookieValue && BLOCKED_AKAMAI_VALUES.includes(cookieValue));
}
